import { Dispatch, useEffect, useRef } from 'react';
import { AppAction } from './startReducer';

export type FrameAction = {
    isEdulla: boolean,
    action: string,
    data: any
}

// Posts a launcher→iframe `widgetMinimized` signal on a showChat true→false
// transition (never on the initial mount), so the iframe can evaluate the
// implicit close-after-nudge dismiss (ADR #55). The iframe owns that heuristic.
export function useWidgetMinimizedSignal(
    showChat: boolean,
    postMessageToFrame: (msg: any) => void
) {
    const wasOpenRef = useRef(showChat);
    useEffect(() => {
        const wasOpen = wasOpenRef.current;
        wasOpenRef.current = showChat;
        if (wasOpen && !showChat) {
            postMessageToFrame({ isEdulla: true, action: 'widgetMinimized', data: {} });
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [showChat]);
}

const isIFrame = (input: HTMLElement | null): input is HTMLIFrameElement =>
    input !== null && input.tagName === 'IFRAME';

export function useIframe(dispatch: Dispatch<AppAction>) {

    const postMessageToFrame = (msg: any) => {
        let frame = document.getElementById('edullaChatWidgetFrame');
        if (isIFrame(frame) && frame.contentWindow) {
            frame.contentWindow.postMessage(msg, "*");
        }
    }


    useEffect(() => {
        const onMessageReceivedFromIframe = (e: any) => {
            let msgData = e.data;
            if (msgData && msgData.isEdulla) {
                switch (msgData.action) {
                    case 'edullaChatState':
                        dispatch({ type: "setEnteredInformation", hasEnteredInformation: msgData.data.enteredInformation })
                        break;
                    case 'setLastLocation':
                        dispatch({ type: "setLastLocation", location: msgData.data })
                        break;
                    case 'closeWidget':
                        dispatch({ type: "setShowChat", showChat: false })
                        break;
                    case 'shrinkWidget':
                        dispatch({ type: "setShrinkWidget", shrinkWidget: msgData.data })
                        break;
                    case 'proactiveMessage': {
                        // The iframe rendered a proactive message and forwarded it so we
                        // can show a teaser while minimized. Idempotent on proactiveMessageId.
                        const text = typeof msgData.data?.text === 'string' ? msgData.data.text : ''
                        const proactiveMessageId = typeof msgData.data?.proactiveMessageId === 'string'
                            ? msgData.data.proactiveMessageId
                            : ''
                        if (text) {
                            dispatch({ type: "setProactiveTeaser", text, proactiveMessageId })
                        }
                        break;
                    }
                }
            }
        }
        window.addEventListener("message", onMessageReceivedFromIframe);
        postMessageToFrame({ isEdulla: true, action: "requestState" });
    }, [dispatch]);
    return postMessageToFrame;
}
